import { noDataCopy } from '../../constants/constants';
import { nudosTextcolor } from '../../styles/styles.constants';
import { Ilocation } from '../../types/global';
import { LOCATION_PLACE_TYPE } from '../../types/services';
import { getLocationIcon } from '../../views/LogisticServices/utils/general.utils';
import { NudosHoverText } from '../NudosComponents';
import { TcountryCode } from '../NudosComponents/BordFlag/BordFlag.types';
import BordPhoto from '../NudosComponents/BordPhoto/BordPhoto';
import './AssetLocationDisplay.scss';

const AssetLocationDisplay = ({ location, locationName }: { location?: Ilocation; locationName: string }) => {
  const { country = 'zz', place } = location || {};
  const iconVariant = getLocationIcon({ place: place as LOCATION_PLACE_TYPE });

  return (
    <div className="assetLocationDisplay">
      <BordPhoto
        variant="circle"
        size="s24"
        flagProps={{
          variant: 'square',
          customWidth: '12px',
          country: country as TcountryCode
        }}
        imageProps={{
          style: {
            borderRadius: '11px',
            objectFit: 'cover',
            height: '100%',
            width: '100%',
            objectPosition: 'center center'
          }
        }}
        oneToneIconProps={{
          variant: iconVariant,
          standardSize: 10,
          stroke: nudosTextcolor
        }}
      />
      <NudosHoverText
        onlyIfTruncated
        customClassName="locationName"
        text={locationName || noDataCopy}
        charactersLimit={17}
      />
    </div>
  );
};

export default AssetLocationDisplay;
